import { render } from "./DialogPaymentLayout.vue?vue&type=template&id=f10be8a2&ts=true"
import script from "./DialogPaymentLayout.vue?vue&type=script&lang=ts"
export * from "./DialogPaymentLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__